import { useSyncExternalStore } from 'react'
import { getSpellActiveWord, subscribeToSpellActiveWord } from '../shape-spell-active-word'
import type { SpellActiveWord } from '../types/spell-active-word'

/** The active misspelled word when it is in this text frame, so only that frame redraws on a change. */
export function useShapeSpellActiveWord(shapeId: string): SpellActiveWord | null {
  return useSyncExternalStore(subscribeToSpellActiveWord, () => {
    const word = getSpellActiveWord()

    return word?.shapeId === shapeId ? word : null
  })
}
